import { render, staticRenderFns } from "./CronjobsManagement.vue?vue&type=template&id=48fbc7cf"
import script from "./CronjobsManagement.vue?vue&type=script&lang=js"
export * from "./CronjobsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports